import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import ActionableItems from 'components/PublicActionableItems';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import queryString from 'query-string';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import ProfileHeader from 'components/ProfileHeader';
import ProfileData from 'components/ProfileData';
import Footer from 'components/MiniFooter';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Session from 'components/SessionReplica';
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import VideoPlayer from 'components/VideoPlayer';
import { logPageView, initGA } from 'utils/analytics';

import style from './AthleteById.scss';// to import local scss fle
import { selector } from './redux';
import { getSAProfile, getProfileForCoach } from './actions';
import { updateConversation } from '../DashBoardCoach/actions';
import { setCurrentVideo } from '../Profile-view/actions';

class AthleteById extends Component {

  static propTypes = {
    profile: PropTypes.shape(),
    match: PropTypes.shape(),
    getSAProfile: PropTypes.func,
    requested: PropTypes.bool,
    getProfileForCoach: PropTypes.func,
    request: PropTypes.shape(),
    conversationUpdated: PropTypes.bool.isRequired,
    location: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    history: {},
    profile: Map(),
    request: Map(),
    getSAProfile: () => {},
    requested: false,
    getProfileForCoach: () => {},
    match: {
      params: {
        id: '',
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      showFullScreenVideo: false,
      videoOnProfile: false,
      showActionableItems: false,
      coachEmail: '',
    };
    this.removeVideoScreen = this.removeVideoScreen.bind(this);
  }

  componentWillMount() {
    const query = queryString.parse(this.props.location.search);
    let publicProfile = false;
    if (query && Object.prototype.hasOwnProperty.call(query, 'coach_email')
        && this.props.match.path === '/athleteForCoach/:id') {
      publicProfile = true;
      const temp = query.coach_email;
      this.setState({ showActionableItems: true, coachEmail: temp });
    }
    const id = this.props.match.params.id;
    if (id && id.length > 0 && !publicProfile) {
      this.props.getSAProfile(id);
    } else {
      this.props.getProfileForCoach(id);
    }
  }
  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.conversationUpdated !== this.props.conversationUpdated) {
      const id = this.props.match.params.id;
      this.props.getProfileForCoach(id);
    }
    if (nextProps.profile.size > 0) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      let profileImage = '';
        let primary_offensive_position_pref = ''; //eslint-disable-line
        let primary_defensive_position_pref = ''; //eslint-disable-line
        let secondary_offensive_position_pref = ''; //eslint-disable-line
        let secondary_defensive_position_pref = ''; //eslint-disable-line
        let special_teams = ''; //eslint-disable-line

      let sat = '';
      let act = '';
      if (nextProps.profile.get('profile_image') !== undefined) {
        profileImage = nextProps.profile.get('profile_image');
      } else {
        profileImage = '';
      }
      let instagramLink = '';
      if (nextProps.profile.get('sa_instagram')) {
        instagramLink = nextProps.profile.get('sa_instagram');
      } else {
        instagramLink = '';
      }
      let twitterLink = '';
      if (nextProps.profile.get('sa_twitter')) {
        twitterLink = nextProps.profile.get('sa_twitter');
      } else {
        twitterLink = '';
      }
      if (sport.get('primary_offensive_position_pref') !== undefined) {
            primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
      } else {
            primary_offensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('primary_defensive_position_pref') !== undefined) {
            primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
      } else {
            primary_defensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('secondary_offensive_position_pref') !== undefined) {
            secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
      } else {
            secondary_offensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('secondary_defensive_position_pref') !== undefined) {
            secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
      } else {
            secondary_defensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('special_teams') !== undefined) {
            special_teams = sport.get('special_teams'); //eslint-disable-line
      } else {
            special_teams = ''; //eslint-disable-line
      }
      const academic = nextProps.profile.get('academic');
      if (academic.get('sat') !== undefined) {
        sat = academic.get('sat');
      }
      if (academic.get('act') !== undefined) {
        act = academic.get('act');
      }


      const newState = {
            // profile
        gender: nextProps.profile.get('gender'),
        fullname: nextProps.profile.get('fullname'),
        state: nextProps.profile.get('sa_state'),
        city: nextProps.profile.get('city'),

            // sports
        height: nextProps.profile.get('height'),
        weight: nextProps.profile.get('weight'),
        sportName: keys[0],
        t40: sport.get('t40'),
        bench: sport.get('bench'),
        squats: sport.get('squats'),
        description: sport.get('description'),

        primary_offensive_position_pref,
        primary_defensive_position_pref,
        secondary_offensive_position_pref,
        secondary_defensive_position_pref,
        special_teams,
            // school
        school: nextProps.profile.get('school'),
        year_of_graduation: academic.get('year_of_graduation'),
        gpa: academic.get('gpa'),
        sat,
        act,
        profileId: nextProps.profile.get('id'),
        video: nextProps.profile.get('video_items').toJS(),
        profile_image: profileImage,
        instagram: instagramLink,
        twitter: twitterLink,
        evaluationText: nextProps.profile.get('evaluation_text'),
      };
      this.setState(newState);
    }
  }
  removeVideoScreen() {
    this.setState({ showFullScreenVideo: !this.state.showFullScreenVideo });
  }
  render() {
    const id = this.props.match.params.id;
    const renderIfProfile = renderIf(this.props.profile.size > 0);
    const renderIfLoading = renderIf(this.props.requested);
    const renderActionableItems = renderIf(this.state.showActionableItems
        && this.props.request.size > 0);
    return (
      <div>
        <div className={style.actionableContainer}>
          {renderActionableItems(
            <ActionableItems {...this.props} {...this.state} />,
      )}
        </div>
        {renderIfLoading(
          <FullScreenLoader />,
          )}
        <VideoPlayer
          removeVideoScreen={this.removeVideoScreen}
          showVideo={this.state.showFullScreenVideo}
          {...this.props}
        />
        {renderIfProfile(
          <div className={cn('row', style.profileContainer)} >
            <ProfileHeader
              {...this.props} {...this.state}
              actionItems={this.state.showActionableItems}
              page={'coachAthleteView'}
              navBarUsedBy={id !== '' ? 'coach' : 'athlete'}
              public="yes"
            />
            <ProfileData
              removeVideoScreen={this.removeVideoScreen}
              {...this.props}
              {...this.state}
              public="yes"
            />
            <Footer />
          </div>,
        )}
      </div>
    );
  }
}


export default connect(selector,
  { getSAProfile,
    setCurrentVideo,
    getProfileForCoach,
    updateConversation,
  })(Session(AthleteById));



// WEBPACK FOOTER //
// ./src/containers/AthleteById/AthleteById.js